import React from "react";

import { Link, Typography as MuiTypography } from "@mui/material";
import clsx from "clsx";

import { TypographyProps } from "./base/types";
import { useTypographyStyles } from "./base/useTypographyStyles";

export const BodyHyperlink: React.FC<TypographyProps> = ({
  text,
  href,
  ...props
}) => {
  const { classes } = useTypographyStyles();

  return (
    <Link href={href} underline="none">
      <MuiTypography
        className={clsx(classes.textBold, classes.body)}
        {...props}
      >
        {text}
      </MuiTypography>
    </Link>
  );
};
